import React, { Component } from 'react';
import PropTypes from 'prop-types';

import NotFound from 'scenes/NotFound';
import Loading from 'scenes/Loading';
import Exchanging from './scenes/Exchanging';
import Success from './scenes/Success';
import Failed from './scenes/Failed';
import NoDeposits from './scenes/NoDeposits';

import './styles.css';

class Exchange extends Component {
  constructor(props) {
    super(props);

    this.setExchange = this.setExchange.bind(this);
    this.renderExchange = this.renderExchange.bind(this);

    this.state = {
      error: false,
    };
  }

  componentWillMount() {
    this.setExchange(this.props.match.params.uuid);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.uuid !== this.props.match.params.uuid) {
      this.setExchange(nextProps.match.params.uuid);
    }
  }

  setExchange(uuid) {
    this.props.exchangeStore.setExchange(uuid, (error) => {
      this.setState({ error });
    });
  }

  renderExchange() {
    if (!this.props.exchangeStore.loaded) return (<Loading />);
    if (!this.props.exchangeStore.exchange) return (<NotFound />);

    switch (this.props.exchangeStore.exchange.status) {
      case 'failed':
        return (
          <Failed
            exchangeStore={this.props.exchangeStore}
            infoStore={this.props.infoStore}
          />
        );
      case 'exchanging':
      case 'sending':
        return (
          <Exchanging
            exchangeStore={this.props.exchangeStore}
            infoStore={this.props.infoStore}
          />
        );
      case 'success':
        return (
          <Success
            exchangeStore={this.props.exchangeStore}
            infoStore={this.props.infoStore}
          />
        );
      case 'no_deposit':
      default:
        return (
          <NoDeposits
            exchangeStore={this.props.exchangeStore}
            infoStore={this.props.infoStore}
          />
        );
    }
  }

  render() {
    return (
      <div className="exchange">
        {this.state.error ?
          <div className="exchange__error">{this.state.error}</div>
        : null}

        {this.renderExchange()}
      </div>
    );
  }
}

Exchange.propTypes = {
  infoStore: PropTypes.object.isRequired,
  exchangeStore: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default Exchange;



// WEBPACK FOOTER //
// ./src/scenes/Exchange/index.jsx